import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageEventArgs, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { MenuFuncionService, ComunidadService, EstadoService, PedidoService, TipoMaterialService, RubroContableService, MaterialesService } from '../../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, SearchPedidoRequestDto, SearchTipoMaterialRequest, TipoMaterialDto, PedidoDto, Comunidad, SearchComunidadRequest, SearchEstadoRequest, Estado, Rol, RubroContable, SearchRubroContableRequest, MaterialDto, SearchMaterialRequest, PedidoItemDto } from '../../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../../shared/model';

@Component({
  selector: 'app-reporte-pedido-material',
  templateUrl: './reporte-pedido-material.component.html',
  styleUrls: ['./reporte-pedido-material.component.scss']
})
export class ReportePedidoMaterialComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isTipoMaterialSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isEstadoSearching: boolean  = false;
  isRolSearching: boolean = false;
  isRubroContableSearching: boolean = false;
  isMaterialAutoSearching: boolean = false;

  canView: boolean = false;
  verSoloMisPendientesAprobacion: boolean = false;
  verSoloActivos: boolean = true;

  filteredComunidadesList: Comunidad[];
  filteredMaterialList: MaterialDto[] = [];
  materialList: MaterialDto[] = [];
  pedidoItem: PedidoItemDto;


  tipoMaterialList: TipoMaterialDto[] = [];
  estadoList: Estado[];
  rolList: Rol[];
  rubroContableList: RubroContable[];
  filteredRubroContableList: RubroContable[];

  total: number = 0;
  searchForm: FormGroup;
  item: PedidoDto;

  public query: Query;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    public sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    private router: Router,
    private menuService: MenuFuncionService,
    private tipoMaterialService: TipoMaterialService,
    private materialService: MaterialesService,
    private service: PedidoService,
    private datePipe: DatePipe,
    private comunidadService: ComunidadService,
    private estadoService: EstadoService,
    private rubroContableService: RubroContableService
    ) {}

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.REPORTE_PEDIDO_ITEMS).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data.Result) {
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.buildForm();

    this.getTipoMaterial();
    this.getAutocompleteComunidadeOrigen();
    this.getMaterialesAutocomplete();

    this.getAutocompleteComunidadeDestino();
    this.getEstados();
    this.getRoles();
    this.getRubroContable();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    var filtros = this.sharedFunctions.getReporteFiltros("app-reporte-pedido-material");
    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchItemsUrl() , //this._serviceUrl + '/search';
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });
  }

  displayComunidad(comunidad: Comunidad): string {
    var displayWith = this.sharedFunctions.formatComunidadName(comunidad);
    return displayWith;
  }

  displayMaterial(material: MaterialDto): string {
    var displayWith = this.sharedFunctions.formatMaterial(material);
    return displayWith;
  }

//#region forms

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'TipoMaterialId': [null],
      'RolId': [null],
      'PedidoId': [null],
      'ComunidadOrigen': [null],
      'MaterialNombre': [null],
      'ComunidadDestino': [null],
      'Estados': [null],
      'RubroContableId': [0],
      'FechaNecesidadDesde': [null],
      'FechaNecesidadHasta': [null],
      'VerSoloMisPendientesAprobacion': [false],
      'gridPage': [1]
    });

    // var filtros = this.sharedFunctions.getReporteFiltros("app-reporte-pedido-material");
    // if (filtros != null)
    //   this.searchForm.patchValue(filtros);
  }

//#endregion

//#region grid

  onActionBegin(args: PageEventArgs) {
    if (args.requestType === 'paging' && !this.isSearching)
    {
      this.searchForm.get('gridPage')?.setValue(args.currentPage);
      this.sharedFunctions.setReporteFiltros("app-reporte-pedido-material", this.searchForm.getRawValue());
    }
  }

//endregion

//#region getters

  getRoles() {
    this.isRolSearching = true;
    this.service.getAprobadores().subscribe(data => {
      this.isRolSearching = false;
      if (data != null)
        this.rolList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isRolSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getRubroContable() {
    var r = new SearchRubroContableRequest(null, null, null, 'Nombre', null, null, true)
    this.isRubroContableSearching = true;
    this.rubroContableService.search(r).subscribe(data => {
      this.isRubroContableSearching = false;
      this.rubroContableList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isRubroContableSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoMaterial() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMateriales() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEstados() {
    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchPedidoEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAutocompleteComunidadeOrigen() {
    this.searchForm.get("ComunidadOrigen")?.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredComunidadesList = [];
        this.isComunidadSearching = true;
    }),
    switchMap(value => this.comunidadService.search(new SearchComunidadRequest(50, null, true, "Nombre", !isNumber(parseInt(value)) ? value : "", null, null, null, null, true))
      .pipe(
        finalize(() => {
          this.isComunidadSearching = false;
        }),
      )
    )
    )
    .subscribe((data: any) => {
      if (data != null && data.result != null) {
        this.filteredComunidadesList = data.result;
      }
      else
        this.filteredComunidadesList = [];
    });
  }

  getAutocompleteComunidadeDestino() {
    this.searchForm.get("ComunidadDestino")?.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredComunidadesList = [];
        this.isComunidadSearching = true;
    }),
    switchMap(value => this.comunidadService.search(new SearchComunidadRequest(50, null, true, "Nombre", !isNumber(parseInt(value)) ? value : "", null, null, null, null, true))
      .pipe(
        finalize(() => {
            this.isComunidadSearching = false;
        }),
      )
    ))
    .subscribe((data: any) => {
      if (data != null && data.result != null)
      {
        this.filteredComunidadesList = data.result;
        console.log("filteredComunidadesList ",this.filteredComunidadesList);
      }
      else
        this.filteredComunidadesList = [];
    });
  }

  getMaterialesAutocomplete() {
    this.searchForm.get('MaterialNombre')?.valueChanges
    .pipe(
      filter(res => {
        return res && res !== null && res.length >= 3
      }),
      distinctUntilChanged(),
      debounceTime(1000),
      tap(() => {
        this.filteredMaterialList = [];
        this.isMaterialAutoSearching = true;
      }),
      //this.searchForm.value.TipoMaterialId
      switchMap(value => this.materialService.search(new SearchMaterialRequest(50, null, true, "Nombre", !isNumber(parseInt(value)) ? value : "",null,this.searchForm.value?.TipoMaterialId ? this.searchForm.value?.TipoMaterialId : "" , true))
        .pipe(
          finalize(() => {
            this.isMaterialAutoSearching = false;
          }),
        )
      )
    )
    .subscribe((data: any) => {
      if (data != null && data.result != null){
        this.filteredMaterialList = data?.result;
      }
      else
        this.filteredMaterialList = [];
    });
  }

//#endregion

//#region grid

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.isSearching = true;

    if (this.searchForm.get('VerSoloMisPendientesAprobacion')?.value == true)
      this.searchForm.get('RolId')?.setValue(null);

    this.searchForm.get('gridPage')?.setValue(1);
    this.sharedFunctions.setReporteFiltros("app-reporte-pedido-material", this.searchForm.getRawValue());

    this.setQueryParams();
    this.grid.refresh();

    this.isSearching = false;
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "TipoMaterialId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMaterialId;
    else
      this.query.addParams("TipoMaterialId",this.searchForm.value.TipoMaterialId);

    index = this.query.params.findIndex(obj => obj.key === "RolId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.RolId;
    else
      this.query.addParams("RolId", this.searchForm.value.RolId);

    index = this.query.params.findIndex(obj => obj.key === "RubroContableId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.RubroContableId;
    else
      this.query.addParams("RubroContableId", this.searchForm.value.RubroContableId);

    index = this.query.params.findIndex(obj => obj.key === "PedidoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PedidoId;
    else
      this.query.addParams("PedidoId", this.searchForm.value.PedidoId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadOrigenId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadOrigen?.Id;
    else
      this.query.addParams("ComunidadOrigenId", this.searchForm.value.ComunidadOrigen?.Id);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadDestinoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadDestino?.Id;
    else
      this.query.addParams("ComunidadDestinoId", this.searchForm.value.ComunidadDestino?.Id);

    index = this.query.params.findIndex(obj => obj.key === "Estados");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Estados?.join(",");
    else
      this.query.addParams("Estados", this.searchForm.value.Estados?.join(","));

    index = this.query.params.findIndex(obj => obj.key === "VerSoloMisPendientesAprobacion");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloMisPendientesAprobacion;
    else
      this.query.addParams("VerSoloMisPendientesAprobacion", this.searchForm.value.VerSoloMisPendientesAprobacion);

      index = this.query.params.findIndex(obj => obj.key === "MaterialId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MaterialNombre?.Id;
    else
      this.query.addParams("MaterialId", this.searchForm.value.MaterialNombre?.Id);

  }

//#endregion

//#region actions

  view(item: PedidoItemDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['pedido-edit', item.PedidoId]);
  }

  onExport() {
    var search = new SearchPedidoRequestDto(null, null, null, "", null, null, null, null, null, this.verSoloActivos, 0, this.verSoloMisPendientesAprobacion, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Pedidos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onExportItem() {
    var search = new SearchPedidoRequestDto(null, null, null, "", null, null, null, null, null, this.verSoloActivos, 0, this.verSoloMisPendientesAprobacion, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearchWithItems(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "PedidosConMateriales_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

}
